export default class Slot {
    constructor(data) {
        this.id = data.id ? data.id : null;
        this.slot_name = data.slot_name ? data.slot_name : null;
        this.semester = data.semester ? data.semester : null;
    }
}